import { render, staticRenderFns } from "./QAIFieldNote.vue?vue&type=template&id=650ae393&"
import script from "./QAIFieldNote.vue?vue&type=script&lang=js&"
export * from "./QAIFieldNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports